export { };
export const defaults = {
	app: {
		applicationId: 'fuelpricesuserfeedback',
		pageEditorClass: 'is-page-editor',
		generalErrorCodes: [
			{ code: '116000', message: 'Es trat ein Fehler beim Zugriff auf das Bestandssystem auf' }
		],
		validatorRules: {
			rules: {
				Uhrzeit: {
					pattern: /^(2[0-3])|([0-1][0-9]):[0-5][0-9]$/
				},
				AnredeKennzeichen: {
					required: true
				},
				PreisSuperE10: {
					pattern: "^[0-9]+(,[0-9]+)?$",
					requirefromgroup: [1, '[data-validation-group="fuelpricecorrection"]']
				},
				PreisSuper: {
					pattern: "^[0-9]+(,[0-9]+)?$",
					requirefromgroup: [1, '[data-validation-group="fuelpricecorrection"]']
				},
				PreisDiesel: {
					pattern: "^[0-9]+(,[0-9]+)?$",
					requirefromgroup: [1, '[data-validation-group="fuelpricecorrection"]']
				},
				EntdecktAm: {
					requireddate: true
				},
				EntdecktUm: {
					required: true
				},
				Anrede: {
					required: true
				},
				Vorname: {
					required: true,
					maxlength: 30,
					nonumber: true
				},
				Nachname: {
					required: true,
					maxlength: 29,
					nonumber: true
				},
				StrasseHausnummer: {
					required: true,
					minlength: 2,
					maxlength: 30,
					streetandnumber: true
				},
				Postleitzahl: {
					required: true,
					minlength: 5,
					maxlength: 5,
					pattern: "[0-9]+"
				},
				Ort: {
					required: true,
					maxlength: 30
				},
				Email: {
					email: true
				},
				TankstelleKorrektur: {
					requirefromgroup: [1, '[data-validation-group="gasstationcorrection"]']
				},
				TankstellePostleitzahl: {
					minlength: 5,
					maxlength: 5,
					pattern: "[0-9]+"
				},
				TankstelleOeffnungszeiten: {
					requirefromgroupif: ['TankstelleGeoeffnetAm', 1, '[data-validation-groupif="businesshours"]']
				},
				Koordinate: {
					pattern: /^[0-9]+([\.\,][0-9]+)?$/
				}
			}
		},
		validationmessages: {
			client: {
				Uhrzeit: {
					pattern: "Bitte geben Sie eine Uhrzeit ein."
				},
				AnredeKennzeichen: {
					required: "Bitte wählen Sie eine Anrede."
				},
				PreisSuperE10: {
					pattern: "Bitte geben Sie eine Zahl ein",
					requirefromgroup: "Bitte geben Sie mindestens eine Preiskorrektur ein."
				},
				PreisSuper: {
					pattern: "Bitte geben Sie eine Zahl ein",
					requirefromgroup: "Bitte geben Sie mindestens eine Preiskorrektur ein."
				},
				PreisDiesel: {
					pattern: "Bitte geben Sie eine Zahl ein",
					requirefromgroup: "Bitte geben Sie mindestens eine Preiskorrektur ein."
				},
				EntdecktAm: {
					requireddate: "Bitte gebenes Sie ein Datum ein."
				},
				EntdecktUm: {
					required: "Bitte geben Sie eine Uhrzeit ein."
				},
				Vorname: {
					maxlength: "Bitte maximal {0} Buchstaben",
					nonumber: "Bitte gebene Sie keine Zahlen ein.",
					required: "Sie haben keinen Vornamen eingegeben. Bitte korrigieren Sie ihre Eingabe."
				},
				Nachname: {
					maxlength: "Bitte maximal {0} Buchstaben",
					required: "Sie haben keinen Nachname eingegeben. Bitte korrigieren Sie ihre Eingabe.",
					nonumber: "Bitte gebene Sie keine Zahlen ein."
				},
				Anrede: {
					required: "Bitte geben Sie Ihre Anrede ein."
				},
				StrasseHausnummer: {
					required: "Bitte geben Sie den Straßennamen und die Hausnummer ein.",
					minlength: "Bitte geben Sie mindestens {0} Zeichen ein.",
					maxlength: "Bitte geben Sie maximal {0} Zeichen ein.",
					streetandnumber: "Bitte korrigieren Sie Ihre Eingabe. Erlaubt sind folgende Sonderzeichen: .,-/’."
				},
				Ort: {
					maxlength: "Bitte geben Sie maximal {0} Zeichen ein.",
					required: "Bitte geben Sie die gültige Postleitzahl und den Ort ein."
				},
				Postleitzahl: {
					maxlength: "Bitte maximal {0} Zahlen",
					minlength: "Bitte mindestens {0} Zahlen",
					required: "Bitte geben Sie die gültige Postleitzahl und den Ort ein.",
					pattern: "Dieses Feld muss korrekt gefüllt sein. Bitte prüfen Sie Ihre Eingabe."
				},
				Email: {
					email: "Bitte geben Sie eine valide E-Mail Adresse ein."
				},
				TankstelleKorrektur: {
					requirefromgroup: "Bitte geben Sie mindestens eine Korrektur ein."
				},
				TankstellePostleitzahl: {
					maxlength: "Bitte maximal {0} Zahlen",
					minlength: "Bitte mindestens {0} Zahlen",
					pattern: "Dieses Feld muss korrekt gefüllt sein. Bitte prüfen Sie Ihre Eingabe."
				},
				TankstelleOeffnungszeiten: {
					requirefromgroupif: "Bitte geben Sie eine der Öffungszeiten ein."
				},
				Koordinate: {
					pattern: "Bitte geben Sie gültige Koordinate ein."
				}
			},
			backend: {}
		}
	}
};